



















































































































































































































import ApiHelper from 'api-helper';
import {Component, Prop, Vue} from 'vue-property-decorator';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import {PLAN_PAYMENT_TYPE} from '@/common/constants/plan';
import moment from 'moment';
import { extend } from 'vee-validate';
import { USER_STATE, USER_TREATMENT_STATE_CAN_ADD_KARTE, NEW_USER_STATE, USER_TREATMENT_STATE_CAN_RESERVE } from '@/common/constants/auth';
import { resolveCancelRequestDetail, resolveCancelRequestReason } from '@/common/helpers/cancel-request';
import {
  isCancelPrescriptionEnabled as resolveCancelPrescriptionEnabled,
  isPrescriptionActionsBlocked as resolvePrescriptionActionsBlocked,
  isPrescriptionNgEnabled as resolvePrescriptionNgEnabled,
} from '@/common/helpers/prescription-button-state';
import PopupConfirm from '@/components/common/PopupConfirm.vue';
import { State } from 'vuex-class';
import { UserTreatment } from '@/models/user-treatment';
import { Patient } from '@/models/patient';
import PlanItem from '../PlanItem.vue';

extend('notSpecialChar', (text) => {
  const textCompare = text;
  if (text) {
    return textCompare.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u203A\u203C-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '').length == text.length
      ? true
      : '絵文字または特殊記号を入力しないでください。';
  }
  return true;
});

@Component({
  components: {
    PageLoader,
    PopupConfirm,
    PlanItem,
  },
  filters: {
    formatTime(value) {
      return (value ? moment(value) : moment()).format('YYYY年 MM月DD日 HH:mm');
    },
    formatDate(value) {
      return (value ? moment(value) : moment()).format('YYYY年MM月DD日');
    },
  },
})
export default class PrescriptionForm extends Vue {

  get queryParams() {
    return {
      ...this.filterParams,
      ...this.paginate,
    };
  }

  private get prescriptionFormRef() {
    return this.$refs.prescriptionForm as any;
  }

  // [SCOPE] No-143: expose the currently-assigned (changed) plan separately so
  // it can render above the LP/normal buckets, and exclude it from those
  // buckets below to avoid rendering the same plan card twice.
  //
  // Guard: only mark the plan as "admin-changed" when prior prescriptions exist
  // AND the latest karte did NOT include this plan — indicating admin changed
  // the plan after the doctor last prescribed. Without this guard the badge
  // appears for any patient who has a plan assigned (including initial
  // registration), misleading doctors into thinking admin just intervened.
  private get changedPlanId() {
    if (!this.activeTreatment.plan) {
      return null;
    }
    if (!this.listFeedback || this.listFeedback.length === 0) {
      // No prior prescriptions → initial registration, not an admin plan change.
      return null;
    }
    const latestFeedback = this.listFeedback[this.listFeedback.length - 1];
    const prescribedPlanIds: number[] = (latestFeedback?.plans ?? []).map((p: any) => Number(p.id));
    const alreadyPrescribed = prescribedPlanIds.includes(Number(this.activeTreatment.plan.id));
    return alreadyPrescribed ? null : this.activeTreatment.plan.id;
  }

  private get changedPlan() {
    if (this.changedPlanId == null) {
      return null;
    }
    return this.listPlanWithMenu.find((plan) => Number(plan.id) === Number(this.changedPlanId)) || null;
  }

  // changedPlan is already rendered in its own block at the top of the template
  // (v-if="changedPlan"), so exclude it here even when it is also recommended.
  private get recommendedPlans() {
    return this.listPlanWithMenu.filter(
      (plan) => plan.recommended === true
        && Number(plan.id) !== Number(this.changedPlanId),
    );
  }

  private get lpPlans() {
    return this.listPlanWithMenu.filter(
      (plan) => plan.selected_from_lp === true
        && Number(plan.id) !== Number(this.changedPlanId)
        && plan.recommended !== true,
    );
  }

  get otherPlans() {
    if (this.prescriptionForm.id == null) {
      const filteredPlans = this.listPlanWithMenu.filter(
        (plan) => !plan.selected_from_lp
          && Number(plan.id) !== Number(this.changedPlanId)
          && plan.recommended !== true,
      );
      return filteredPlans;
    }
    return [];
  }

  private get prescriptionContainerStyle() {
    if (!this.windowInnerHeight) {
      return {};
    }
    // 58%: empirical value to avoid clipping the form footer on the smallest supported viewport (667px / iPhone SE)
    return { height: `${Math.floor(this.windowInnerHeight * 0.58)}px` };
  }

  private get isDisableButtonSave() {
    if ( this.isPrescription || this.isNG || this.isCancel || this.isReverse ) {
      return false;
    } else {
      return true;
    }
  }

  private get isDisableCreateFeedback() {
    return !USER_TREATMENT_STATE_CAN_ADD_KARTE.includes(this.activeTreatment.state);
  }

  private get isPrescriptionActionsBlocked(): boolean {
    return resolvePrescriptionActionsBlocked(this.activeTreatment.state);
  }

  private get isPrescriptionNgDisabled(): boolean {
    return !resolvePrescriptionNgEnabled(this.activeTreatment.state);
  }

  private get isCancelPrescriptionDisabled(): boolean {
    return (
      !resolveCancelPrescriptionEnabled(this.activeTreatment.state, 'chat')
    );
  }

  private get isReservePrescriptionDisabled(): boolean {
    return (
      this.isPrescriptionActionsBlocked ||
      this.checkButtonReserve ||
      this.checkDoctorReserve
    );
  }

  private get isSaveButtonDisabled(): boolean {
    return this.isDisableButtonSave || this.isPrescriptionActionsBlocked;
  }

  private get checkDoctorReserve() {
    return !USER_TREATMENT_STATE_CAN_RESERVE.includes(this.activeTreatment.state);
  }

  private get checkButtonReserve() {
    return this.activeTreatment.feedback_type === NEW_USER_STATE.DOCTOR_RESERVE_PRESCRIPTION;
  }

  private get isDisabled(): boolean {
    return this.isSubmitting || (this.prescriptionForm.id > 0 && !this.isReverse);
  }
  @Prop() changeState: any;

  paginate = {
    page: 1,
    per_page: 20,
    last_page: 1,
  };

  filterParams = {
    with: 'plans',
    select_fields: 'id,name,status,is_default',
    has_plans: 1,
    clinic_ids: [] as number[],
    ids_not_in: [] as number[],
  };
  @Prop() currentChannelUser!: any;
  @Prop() listFeedback: any;
  @State((state) => state.treatment_detail.data) activeTreatment: UserTreatment;
  @State((state) => state.patient_detail.data) currentPatient!: Patient;
  @State((state) => state.patient_detail.data) patient: Patient;


  /**
   * Only shown while the treatment is still in キャンセル申請中: once the
   * cancellation is carried out the reason belongs to the treatment history,
   * not to a form the doctor is filling in.
   */
  get cancelRequestReason(): string | null {
    return resolveCancelRequestReason(this.activeTreatment);
  }

  get cancelRequestDetail(): string | null {
    return resolveCancelRequestDetail(this.activeTreatment);
  }

  protected PRESCRIPTION_TYPE = {
    PRESCRIPTION: 'prescription',
    NG: 'ng',
    CANCEL_PRESCRIPTION: 'cancel_prescription',
    RESERVE_PRESCRIPTION: 'reserve_prescription',
  };
  private isSubmitting: boolean = false;
  private isLoading: boolean = false;
  private listPlan: any[] = [];
  private listPlanWithMenu: any[] = [];
  private listPlanIdWithMenu: any[] = [];
  private selectedPlans: any[] = [];

  private PLAN_PAYMENT_TYPE: any = PLAN_PAYMENT_TYPE;
  private prescriptionForm: any = {
    content: null,
    type: null,
    plans: [],
  };
  private isPrescription: boolean = false;
  private isNG: boolean = false;
  private isCancel: boolean = false;
  private isReverse: boolean = false;
  private prescriptionType: string = '';
  private planSuggestListEl: Element|null;
  private windowInnerHeight: number = typeof window !== 'undefined' ? window.innerHeight : 0;

  mounted() {
    this.getListPlansWithMenu();
    window.addEventListener('resize', this.onWindowResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  hideModal() {
    if (!this.isSubmitting) {
      this.resetPrescriptionForm();
      this.$modal.hide('prescriptionForm');
      this.$modal.hide('chat-channel-popup'); // hide modal chat question in chat channel
    }
  }

  hidenModal() {
    this.resetPrescriptionForm();
    this.$modal.hide('prescriptionForm');
    this.$modal.hide('chat-channel-popup');
  }

  show(currentPrescription) {
    this.prescriptionForm = currentPrescription;
    this.prescriptionType = currentPrescription.type;
    this.$modal.show('prescriptionForm');
  }

  getListPlansWithMenu() {
    this.isLoading = true;
    const self = this;
    const payload = { user_treatment_id: this.activeTreatment.id, with: ['medicines:id,name,usage'] };
    ApiHelper.getApi('PatientV2Api')
      .getPlansByPatientId(this.currentChannelUser.id, payload)
      .then(function(res) {
        self.listPlanWithMenu = res.data;
        self.listPlanIdWithMenu = res.data?.map((plan) => plan.id) || [];
        // self.getListPlans();
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.isLoading = false;
      });
  }

  getListPlans() {
    this.isLoading = true;
    const self = this;
    if (this.paginate.page > this.paginate.last_page && this.paginate.last_page >= 1) {
      this.isLoading = false;
      return;
    }

    if (this.currentPatient && this.currentPatient.clinics.length > 0) {
      this.filterParams = {
        ...this.filterParams,
        clinic_ids: [this.patient.clinics[0].id],
        ids_not_in: [this.activeTreatment?.menu?.id ?? 0],
      };
    }

    ApiHelper.getApi('MedicalMenuV2Api')
      .fetchPlanListV2(this.queryParams)
      .then(function(res) {
        const lastPage = res ? res.meta.last_page : 1;
        if (self.paginate.page * self.paginate.per_page > self.listPlan.length + res.data.length - 1) {
          let plans = res.data || [];
          if (self.listPlanIdWithMenu.length > 0) {
            plans = plans.filter((plan) => !self.listPlanIdWithMenu.includes(plan.id));
          }
          self.listPlan = [...self.listPlan, ...plans];
        }

        self.paginate = {
          ...self.paginate,
          page: lastPage >= self.paginate.page ? self.paginate.page + 1 : self.paginate.page,
          last_page: lastPage,
        };
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.isLoading = false;
      });
  }

  handleScroll(event) {
    const container = event.target;
    const { scrollTop, scrollHeight, clientHeight } = container;

    // No-75 Displays a list of non-clinic services
    // if (scrollTop + clientHeight >= scrollHeight - 1 && !this.isLoading) {
    //   this.getListPlans();
    // }
  }

  prescriptionHandle() {
    this.isPrescription = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.PRESCRIPTION;
    const self = this;
    setTimeout(function() {
      self.planSuggestListEl = document.querySelector('div.plan-suggest-list');
      self.planSuggestListEl?.addEventListener('scroll', self.handleScroll);
    }, 100);
  }

  ngHandle() {
    this.isNG = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.NG;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.NG;
  }

  cancelPrescription() {
    this.isCancel = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION;
  }

  reservePrescription() {
    this.isReverse = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION;
  }

  async savePrescriptionForm() {
    const isValid = await this.prescriptionFormRef.validate();
    if (!isValid) {
      return;
    }
    if (this.listFeedback.length > 0) {
      this.$modal.show('confirmCreateKarte');
      return true;
    }
    this.createKarte();
  }

  async createKarte() {
    const data = {
      user_id: this.currentChannelUser.id,
      content: this.prescriptionForm.content,
      plans: this.prescriptionForm.type === this.PRESCRIPTION_TYPE.PRESCRIPTION ? this.prescriptionForm.plans : null,
      type: this.prescriptionForm.type,
      user_treatment_id: this.activeTreatment.id,
    };
    this.isSubmitting = true;
    const self = this;
    let feedback = null;

    if (this.prescriptionForm.id) {
      await ApiHelper.getApi('DoctorMouthApi').updateFeedback(this.prescriptionForm.id, data)
        .then((res) => {
          feedback = res.data;
          Toast.success('カルテ作成が完了しました。');
        })
        .catch((error: any) => {
          error.response && Toast.error(error.response.data.message);
        })
        .finally(function() {
          self.isSubmitting = false;
          self.$modal.hide('prescriptionForm');
        });
    } else {
      await ApiHelper
        .getApi('PatientV2Api')
        .createFeedback(this.currentPatient.id, data)
        .then((res, error) => {
          feedback = res.data;
          switch (this.prescriptionType) {
            case this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION:
              Toast.success('処方保留が完了しました。');
              break;
            case this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION:
              Toast.success('処方をキャンセルしました。');
              this.hidenModal();
              break;
            default:
              Toast.success('カルテ作成が完了しました。');
              break;
          }
        })
        .catch((error: any) => {
          const { response: { data: { code, message } }} = error;
          if (code && code === 'errors.exists_doctor_feedback_for_user') {
            return Toast.error('カルテが既に作成されています。');
          }
          message && Toast.error(message);
        })
        .finally(function() {
          self.isSubmitting = false;
          self.$modal.hide('prescriptionForm');
          self.$modal.hide('confirmCreateKarte');
        });
    }
    this.resetPrescriptionForm();
    self.$emit('savedFeedback', feedback);
  }

  cancelPopupConfirm() {
    this.$modal.hide('confirmCreateKarte');
  }

  handlePlanChange(plan) {
    const index = this.selectedPlans.findIndex(
      (item) => item.planId === plan.id,
    );

    const isChecked = this.prescriptionForm.plans.includes(Number(plan.id));

    if (isChecked) {
      if (index === -1) {
        this.selectedPlans.push(
          {
            planId: plan.id,
            prescriptionId: this.prescriptionForm.id || null,
          },
        );
      }
    } else {
      if (index !== -1) {
        this.selectedPlans.splice(index, 1);
      }
    }
  }

  resetPrescriptionForm() {
    this.prescriptionForm = { content: null, type: null, plans: [] };
    this.prescriptionType = '';
    this.isPrescription = false;
    this.isNG = false;
    this.isCancel = false;
    this.isReverse = false;
    if (this.prescriptionFormRef) {
      this.prescriptionFormRef.reset();
    }
  }

  private onWindowResize() {
    this.windowInnerHeight = window.innerHeight;
  }
}
